module.exports = __webpack_public_path__ + "static/media/SlideArrowRightBlack.5e91acdc.svg";